export default {
    host:"https://tpan.ir",
    //host:"http://localhost:3001",
    chathost:"https://chat.tpan.ir",
    panelhost:"https://panel.tpan.ir",
    apikey:"8ee7d17a-2ec9-4fdd-853d-4eec4edb503d",
    version:"0.7.0"
}